/**
 *
 * Asynchronously loads the Data Group container
 *
 */

import { lazy } from 'react';

export const DataGroups = lazy(() =>
  import('./index').then(module => ({ default: module.DataGroups })),
);
